import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import bgimg from "../assets/imgs/bg.jpeg"
import { saveEmail, checkEmailExist } from "../api/api";
const EmailPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const BuyMeACoffeeButton = () => {
    return (
      <a href="https://buymeacoffee.com/greghalpern" target="_blank" rel="noopener noreferrer" className="fixed bottom-4 right-4 bg-yellow-500 text-white p-3 rounded-full shadow-lg">
        <span role="img" aria-label="coffee cup">☕</span> Buy Me A Coffee
      </a>
    );
  };

  const handleClose=()=>{
    window.location.href = "https://whatthatmeans.net/";
    }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const responseData = await checkEmailExist(email);
      
      if (responseData && responseData.message === "email does not exist") {
        const saved = await saveEmail(email);
        if (saved) {
          Swal.fire({
            title: 'Vote First',
            text: 'First, cast your vote,You will be directed to The Peoples Vote website in 3 seconds',
            icon: 'info',
            timer: 3000, // Show for 3 seconds
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading();
            },
          });
      
          // Redirect after 3 seconds
          setTimeout(() => {
            window.location.href = "https://thepeoplesvote.us/";
          }, 3000);
          // window.location.href = "https://thepeoplesvote.us/";

        } else {
          setError("Failed to save email. Please try again.");
        }
      } else if (responseData && responseData.message === "email exists") {
        navigate("/accesspage");
      } else {
        setError("Unexpected response. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
<div
  className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 bg-cover bg-center"
  style={{ backgroundImage: `url(${bgimg})`}}
>      <div className="bg-white p-6 rounded shadow-md w-[80%] md:w-[40%] lg:w-[25%] bg-gradient-to-r from-[#8AA7F3] to-[#FEA5B9]">
        <h2 className="text-xl text-[#212060] font-extrabold mb-4">ENTER EMAIL TO GET NEXT LEVEL ACCESS AND AMAZING FREE GIFTS</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-gray-300 p-3  mb-4 w-full rounded-xl placeholder: font-mono text-xl"
            placeholder="ENTER YOUR EMAIL"
            required
          />
          {error && <p className="text-red-500 mb-2">{error}</p>}
          <div className="flex justify-between">
         
            <button type="button" onClick={handleClose} className="bg-white px-4 py-2 rounded-md  text-black text-xl font-bold">
              Cancel
            </button>

            <button type="submit" className="bg-[#212060] text-white px-4 py-2 rounded-md font-bold text-xl" disabled={loading}>
              {loading ? 'Loading...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>

      <BuyMeACoffeeButton/>
    </div>

  );
};

export default EmailPopup;
